import styled, { css } from "styled-components";
import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";
import { ImageType } from "./CardsSectionModel";

export const CardsSectionContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: ${COLORS.VividAuburn};
  border-radius: ${BORDER_RADIUS.radius24};
  padding-block: ${SIZE.max140};
  padding-inline: ${SIZE.max224};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1120px) {
    padding-block: ${SIZE.max224};
    padding-inline: ${SIZE.max400};
  }

  @media (max-width: 900px) {
    padding-block: ${SIZE.max140};
    padding-inline: ${SIZE.max224};
  }

  @media (max-width: 768px) {
    padding-block: ${SIZE.max120};
    padding-inline: ${SIZE.max120};
  }

  @media (max-width: 600px) {
    padding-block: ${SIZE.max80};
    padding-inline: ${SIZE.max80};
  }
`;

export const LimitedWidthContainer = styled.div`
  max-width: 1500px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CirclesWrapper = styled.div`
  z-index: 1;
`;
export const CardsSectionContentWrapper = styled.div`
  z-index: 5;
  /* position: relative; */
  display: grid;
  /* grid-template-columns: repeat(6, 1fr); */
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: ${SIZE.max24};
  grid-row-gap: ${SIZE.max24};
  @media (max-width: 1600px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1120px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const CardsSectionCard = styled.div`
  background-color: ${COLORS.FaluRed};
  border-radius: ${BORDER_RADIUS.radius24};
  width: ${SIZE.max472};
  aspect-ratio: 1/1;

  @media (max-width: 1600px) {
    width: 100%;
  }
`;

export const FirstCardTitleWrapper = styled.div`
  display: flex;
  column-gap: 6px;
`;

export const FirstCardTextWrapper = styled.div``;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${BORDER_RADIUS.radius24};
`;

export const CareerCardTextWrapper = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;

export const CareerCardImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: ${SIZE.max55} 0;

  @media (max-width: 1600px) {
    margin-inline: ${SIZE.max80} 0;
  }

  @media (max-width: 450px) {
    margin-inline: ${SIZE.max24} 0;
  }
`;

export const CareerCardImage = styled.img`
  height: ${SIZE.max180};

  @media (max-width: 1600px) {
    height: ${SIZE.max200};
  }

  @media (max-width: 768px) {
    height: ${SIZE.max160};
  }

  @media (max-width: 450px) {
    height: ${SIZE.max120};
  }
`;

export const FirstCardWrapper = styled(CardsSectionCard)`
  grid-area: 1 / 1 / 3 / 3;
  padding: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  @media (max-width: 1600px) {
    grid-area: 1 / 1 / 3 / 3;
  }

  @media (max-width: 1120px) {
    grid-area: 1 / 1 / 3 / 3;
    aspect-ratio: 2/1;
  }
`;

export const SecondCardWrapper = styled(CardsSectionCard)`
  grid-area: 1 / 3 / 3 / 5;
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  background-color: transparent;
  height: 100%;
  @media (max-width: 1600px) {
    grid-area: 1 / 3 / 3 / 5;

    justify-content: space-between;
  }

  @media (max-width: 1120px) {
    grid-area: 3 / 1 / 5 / 3;
  }
`;

export const ThirdCardWrapper = styled(CardsSectionCard)`
  grid-area: 1 / 5 / 3 / 7;
  background-color: transparent;
  display: flex;
  column-gap: ${SIZE.max24};
  height: 100%;
  @media (max-width: 1600px) {
    grid-area: 3 / 1 / 5 / 3;
  }

  @media (max-width: 1120px) {
    grid-area: 5/1/7/3;
  }
`;

export const FourthCardWrapper = styled(CardsSectionCard)`
  grid-area: 3 / 1 / 5 / 3;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};

  @media (max-width: 1600px) {
    grid-area: 3 / 3 / 5 / 5;
  }

  @media (max-width: 1120px) {
    grid-area: 9 / 1 / 11 / 3;
  }
`;

export const FifthCardWrapper = styled(CardsSectionCard)`
  grid-area: 3 / 3 / 5 / 5;
  padding: ${SIZE.max40};

  @media (max-width: 1600px) {
    grid-area: 5 / 1 / 7 / 3;
    height: 100%;
    max-height: 400px;
  }

  @media (max-width: 1120px) {
    aspect-ratio: 2/1;
    grid-area: 7 / 1 / 9 / 3;
    max-height: none;
    height: fit-content;
  }
`;

export const SixthCardWrapper = styled(CardsSectionCard)`
  grid-area: 3 / 5 / 5 / 7;
  padding: ${SIZE.max40};

  @media (max-width: 1600px) {
    grid-area: 5 / 3 / 7 / 5;
    height: 100%;
    max-height: 400px;
  }

  @media (max-width: 1120px) {
    grid-area: 11 / 1 / 13 / 3;
    aspect-ratio: 2/1;
    max-height: none;
    height: fit-content;
  }
`;

export const SeventhCardWrapper = styled.div`
  grid-area: 5 / 1 / 6 / 3;

  background-color: ${COLORS.FaluRed};
  border-radius: ${BORDER_RADIUS.radius24};
  height: ${SIZE.max224};
  background-color: ${COLORS.Yellow};
  transition: background-color 0.4s ease-out;
  text-decoration: none;
  cursor: pointer;
  padding: ${SIZE.max40};
  display: flex;

  :hover {
    background-color: ${COLORS.Orange};
  }

  @media (max-width: 1600px) {
    grid-area: 8 / 1 / 9 / 3;
    height: 100%;
    aspect-ratio: 2/1;
  }

  @media (max-width: 1120px) {
    grid-area: 15 / 1 / 16 / 3;
  }

  @media (max-width: 450px) {
    padding-inline: ${SIZE.max24};
    padding-block: ${SIZE.max24};
  }
`;

export const EighthCardWrapper = styled(CardsSectionCard)`
  grid-area: 5 / 3 / 6 / 5;
  aspect-ratio: 2/1;
  background-color: transparent;
  height: 100%;
  @media (max-width: 1600px) {
    grid-area: 7 / 1 / 8 / 5;
    aspect-ratio: 4/1;
  }

  @media (max-width: 1120px) {
    grid-area: 14 / 1 / 15 / 3;
    aspect-ratio: 2/1;
  }
`;

export const NinthCardWrapper = styled(CardsSectionCard)`
  grid-area: 5 / 5 / 6 / 6;
  aspect-ratio: 2/1;
  background-color: transparent;
  height: 100%;
  @media (max-width: 1600px) {
    grid-area: 8 / 3 / 9 / 5;
    width: 100%;
  }

  @media (max-width: 1120px) {
    grid-area: 13 / 1 / 14 / 3;
  }
`;

export const CardImageWrapper = styled.div<{ type: string }>`
  border-radius: ${BORDER_RADIUS.radius24};
  overflow: hidden;
  ${({ type }) =>
    type === ImageType.SQUARE_SMALL &&
    css`
      width: ${SIZE.max224};
      /* height: ${SIZE.max224}; */
      height: 100%;
      @media (max-width: 1600px) {
        width: 100%;
        height: 100%;
      }
    `}

  ${({ type }) =>
    type === ImageType.RECTANGULAR_LONG &&
    css`
      /* height: ${SIZE.max224}; */
      height: 100%;
      width: ${SIZE.max472};

      @media (max-width: 1600px) {
        width: 100%;
        height: 100%;
      }
    `}

  ${({ type }) =>
    type === ImageType.RECTANGULAR_TALL &&
    css`
      /* height: ${SIZE.max472}; */
      height: 100%;
      width: ${SIZE.max224};

      @media (max-width: 1600px) {
        width: 100%;
        height: 100%;
      }
    `}
`;

export const CardTextWrapper = styled.div`
  background-color: ${COLORS.FaluRed};
  height: calc((100% - ${SIZE.max24}) / 2);
  border-radius: ${BORDER_RADIUS.radius24};
  padding-inline: ${SIZE.max55};
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HorizontalWrapper = styled.div`
  display: flex;
  column-gap: ${SIZE.max24};
  height: calc((100% - ${SIZE.max24}) / 2);

  @media (max-width: 1600px) {
  }
`;

export const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  width: calc((100% - ${SIZE.max24}) / 2);
  height: 100%;
`;

export const NinthHorizontalWrapper = styled.div`
  display: flex;
  column-gap: ${SIZE.max24};
  height: 100%;
  @media (max-width: 1600px) {
    height: 100%;
  }
`;
